import { Socket } from 'socket.io-client';
import { SocketName } from '../../shared/typings/socket-connection';
import { getNewMessageSocket } from './index';
import { getOrganizationsSocket } from './organization-socket';
import { getUserSocket } from './user-socket';

const socketGetters: Record<SocketName, () => Socket> = {
  [SocketName.CONVERSATION]: getNewMessageSocket,
  // [SocketName.ORGANIZATION]: getOrganizationsSocket,
  // [SocketName.USER]: getUserSocket,
};

export const reconnectSocketByName = (name: SocketName): void => {
  const socket = socketGetters[name]?.();
  if (socket) {
    socket.disconnect();
    socket.connect();
  }
};
